import { useMemo } from 'react';
import { ReportUtils } from '@snapi/utils';
import { ReportSummary } from '@snapi/types';
import { GutBalanceCard } from './gut-balance-card';
import { DiversityCard } from './diversity-card';
import { ReportHeaderHero } from './report-header-hero';

interface ReportHeaderProps {
  summary: ReportSummary;
  onSelect: (name: string) => void;
  reportedAt?: string | null;
}

export const ReportHeader: React.FC<ReportHeaderProps> = ({
  summary: { diversity, keyBacteria, disruptive, balance },
  onSelect,
  reportedAt,
}) => {
  const numberOfGood = useMemo(
    () =>
      (ReportUtils.diversity.isGood(diversity.score) ? 1 : 0) +
      (ReportUtils.balance.isGood(
        ReportUtils.balance.calculateScore(
          balance.protective,
          balance.disruptive
        )
      )
        ? 1
        : 0) +
      (ReportUtils.disruptive.isGood(disruptive.bacteria) ? 1 : 0) +
      (ReportUtils.keyBacteria.isGood(keyBacteria.bacteria) ? 1 : 0),
    [diversity, disruptive, keyBacteria, balance]
  );

  return (
    <header className="bg-purple text-purple-dark pb-16">
      <ReportHeaderHero
        numberOfGood={numberOfGood}
        reportedAt={reportedAt || null}
      />

      <div className="flex flex-col items-center w-full container gap-3 sm:flex-row sm:justify-center sm:gap-4 md:gap-8">
        <DiversityCard {...diversity} />
        <GutBalanceCard {...balance} />
      </div>
    </header>
  );
};
